import * as E from "@wix/bi-logger-rich-editor/v2";
import { Node_Type } from "./../../ricos-types";
import { Decoration_Type } from "./../../wix-rich-content-common";
import { RicosBILogger } from "./RicosBILogger";
import uuid from "./uuid";
const onPluginActionMap = {
  addPluginLink: E.addPluginLink,
  searchForPlugin: E.searchForPlugin,
  searchInsideThePlugin: E.searchInsideThePlugin,
  pluginTableColumnRowAction: E.pluginTableColumnRowAction,
  tablePluginAddColumnRow: E.tablePluginAddColumnRow,
  tablePluginDeleteColumnRow: E.tablePluginDeleteColumnRow,
  tablePluginClickOnOptionMenu: E.tablePluginClickOnOptionMenu,
  tablePluginClickActionFromOptionMenu: E.tablePluginClickActionFromOptionMenu,
  settingsModalOpenedForPlugin: E.settingsModalOpenedForPlugin,
  settingsModalClosedForPlugin: E.settingsModalClosedForPlugin
};
const rce_session_id = uuid();
const ricosBICallbacks = ({
  consumer: container = "default",
  appDefId: container_id = "empty",
  platform: container_platform,
  usage: container_usage,
  postId,
  wixRicosVersion,
  ricosVersion,
  metaSiteId,
  webBiLogger,
  logger,
  defaultParams: essentials = {}
}) => {
  const genericParams = {
    container,
    container_id,
    container_platform,
    container_usage,
    post_id: postId,
    rce_session_id,
    msid: metaSiteId,
    wixRicosVersion,
    version: ricosVersion
  };
  const biLogger = new RicosBILogger({ logger, webBiLogger, genericParams, essentials });
  return {
    onModalAction: ({ pluginId, modalId, modalSessionId, actionName, value, actionNumber }) => {
      biLogger.log(modalAction, {
        action: actionName,
        modal_session_id: modalSessionId,
        numActions: actionNumber - 1,
        actionNumber,
        modal_id: modalId,
        plugin_id: pluginId,
        content_id: "",
        uuid: "",
        // @ts-expect-error not yet declared on the event
        value
      });
    },
    onPluginAdd: (plugin_id, entry_point, version, content_id) => biLogger.log(E.addPlugin, {
      plugin_id,
      search_term: void 0,
      entry_point,
      version,
      content_id,
      entry_type: void 0,
      plugins_details: void 0,
      pluginUniqueId: void 0,
      button_name: void 0,
      plugin_specification: void 0,
      editor_engine: void 0
    }),
    onPluginAddStep: ({
      entryPoint,
      entryType,
      pluginDetails,
      pluginId,
      step,
      version,
      contentId: content_id
    }) => biLogger.log(E.addPluginStep, {
      entry_point: entryPoint,
      entry_type: entryType,
      params: void 0,
      plugin_id: pluginId,
      pluginUniqueId: pluginDetails,
      plugins_details: void 0,
      step,
      version,
      content_id,
      plugin_specification: void 0
    }),
    onPluginAddSuccess: (plugin_id, entry_point, params, version, content_id) => biLogger.log(E.addPluginSuccess, {
      plugin_id,
      entry_point,
      entry_type: void 0,
      params: JSON.stringify(params),
      plugins_details: void 0,
      pluginUniqueId: void 0,
      version,
      content_id,
      plugin_specification: void 0,
      editor_engine: void 0,
      is_tiptap: void 0,
      mediaOrigin: void 0
    }),
    onPluginDelete: ({ pluginId, pluginDetails, version, contentId: content_id }) => biLogger.log(E.deletePlugin, {
      plugin_id: pluginId,
      plugins_details: JSON.stringify(pluginDetails || {}),
      pluginUniqueId: void 0,
      version,
      content_id,
      editor_engine: void 0
    }),
    onPluginChange: (plugin_id, pluginDetails, version, content_id) => biLogger.log(E.changePlugin, {
      plugin_id,
      plugins_details: JSON.stringify(pluginDetails),
      settingSessionId: void 0,
      button_name: void 0,
      category: void 0,
      origin: void 0,
      type: void 0,
      value: void 0,
      pluginUniqueId: void 0,
      version,
      content_id,
      editor_engine: void 0
    }),
    onPublish: (post_id, plugins_count, _plugins_details, version, content_id) => biLogger.log(E.publishPost, {
      post_id: post_id || postId,
      plugins_count: plugins_count ? JSON.stringify(plugins_count) : void 0,
      plugins_details: "",
      // plugins_details && JSON.stringify(_plugins_details),
      params: void 0,
      version,
      content_id,
      editor_engine: void 0,
      is_tiptap: void 0
    }),
    onMenuLoad: ({ menu, version, contentId: content_id }) => biLogger.log(E.menuLoad, {
      menu,
      version,
      content_id
    }),
    onPluginModalOpened: ({
      entryPoint,
      entryType,
      pluginDetails,
      pluginId,
      version,
      contentId: content_id,
      dropdownValue,
      modalSessionId
    }) => biLogger.log(E.pluginModalOpened, {
      entry_point: entryPoint,
      entry_type: entryType,
      plugin_id: pluginId,
      plugins_details: JSON.stringify(pluginDetails),
      version,
      content_id,
      plugin_specification: void 0,
      editor_engine: void 0,
      is_tiptap: void 0,
      dropdown_value: dropdownValue,
      modal_session_id: modalSessionId
    }),
    onViewerAction: (plugin_id, action_name, value, content_id, partialNode) => {
      biLogger.log(E.viewerAction, {
        action_name,
        plugin_id,
        value,
        plugins_details: void 0,
        pluginUniqueId: void 0,
        content_id,
        params: void 0,
        productType: void 0,
        plugin_specification: void 0
      });
      const analyticsData = buildAnyButtonClickActionParams(content_id, partialNode);
      if (analyticsData) {
        biLogger.log(analyticsAnyButtonClickAction, analyticsData);
      }
    },
    onViewerLoaded: ({ isPreview, url: postURL, pluginsCount, version, contentId: content_id }) => {
      const preview = typeof isPreview === "boolean" ? isPreview : typeof isPreview === "string" && isPreview === "true";
      biLogger.log(E.viewerLoaded, {
        preview,
        postURL,
        version,
        content_id,
        pluginsCount: JSON.stringify(pluginsCount)
      });
    },
    onOpenEditorSuccess: (version, toolbarType, content_id) => biLogger.log(E.openEditorSuccess, {
      toolbarType,
      version,
      content_id,
      editor_engine: void 0,
      is_tiptap: void 0
    }),
    onContentEdited: ({ version, contentId: content_id }) => biLogger.log(E.contentAdded, {
      version,
      content_id,
      contact_id: void 0,
      container_type: void 0,
      editing_time: void 0,
      paragraph_count: void 0,
      word_count: void 0,
      editor_engine: void 0,
      is_tiptap: void 0
    }),
    onInlineToolbarOpen: ({ version, toolbarType, pluginId, contentId: content_id }) => biLogger.log(E.inlineToolbarOpened, {
      version,
      content_id,
      toolbarType,
      plugin_id: pluginId
    }),
    onToolbarButtonClick: ({
      buttonName,
      category,
      origin,
      pluginDetails,
      pluginId,
      pluginUniqueId,
      type,
      value,
      version,
      contentId: content_id
    }) => biLogger.log(E.changePlugin, {
      button_name: buttonName,
      category,
      origin,
      pluginUniqueId,
      plugin_id: pluginId,
      plugins_details: pluginDetails,
      type,
      value,
      version,
      content_id,
      settingSessionId: void 0,
      editor_engine: void 0
    }),
    onKeyboardShortcutAction: ({ buttonName, pluginId, value, version, contentId: content_id }) => biLogger.log(E.keyboardShortcutAction, {
      button_name: buttonName,
      category: void 0,
      origin: void 0,
      pluginUniqueId: void 0,
      plugin_id: pluginId,
      plugins_details: void 0,
      type: void 0,
      value,
      version,
      content_id,
      settingSessionId: void 0
    }),
    onMediaUploadStart: (correlationId, plugin_id, fileSize, mediaType, version, content_id) => {
      biLogger.log(E.uploadMediaTry, {
        plugin_id,
        correlationId,
        fileSize,
        mediaType,
        type: void 0,
        version,
        content_id
      });
    },
    onMediaUploadEnd: (correlationId, plugin_id, duration, fileSize, mediaType, isSuccess, errorReason, version, content_id) => {
      biLogger.log(E.uploadMediaFinished, {
        plugin_id,
        correlationId,
        duration,
        fileSize,
        mediaType,
        isSuccess,
        errorReason,
        type: void 0,
        version,
        content_id
      });
    },
    onPluginAction: (eventName, eventParams) => {
      if (eventParams.params) {
        const params = JSON.stringify(eventParams.params);
        eventParams.params = params;
      }
      const { contentId: content_id, ...rest } = eventParams || {};
      biLogger.log(onPluginActionMap[eventName], {
        content_id,
        version: void 0,
        plugins_details: void 0,
        ...rest
      });
    },
    onPluginsPopOverTabSwitch: ({ pluginId, buttonName, version, contentId: content_id }) => {
      biLogger.log(E.pluginsPopoverTabSwitch, {
        plugin_id: pluginId,
        button_name: buttonName,
        content_id,
        version,
        plugins_details: void 0,
        pluginUniqueId: void 0,
        settingSessionId: void 0,
        category: void 0,
        origin: void 0,
        value: void 0,
        type: void 0
      });
    },
    onPluginsPopOverClick: ({ pluginId, buttonName, version, contentId: content_id }) => {
      biLogger.log(E.pluginsPopoverClick, {
        plugin_id: pluginId,
        button_name: buttonName,
        content_id,
        version,
        plugins_details: void 0,
        pluginUniqueId: void 0,
        settingSessionId: void 0,
        category: void 0,
        origin: void 0,
        value: void 0,
        type: void 0
      });
    },
    onChangePluginSettings: ({ pluginId, actionName, value, version, contentId: content_id }) => {
      biLogger.log(E.changePluginSettings, {
        plugin_id: pluginId,
        actionName,
        content_id,
        value,
        version,
        container: void 0,
        container_id: void 0,
        container_platform: void 0,
        entry_point: void 0,
        entry_type: void 0,
        layout: void 0,
        params: value,
        pluginUniqueId: void 0,
        plugins_details: void 0
      });
    },
    mediaPluginsDetails: ({
      pluginId,
      creator,
      title,
      track_duration,
      url,
      type,
      version,
      contentId: content_id
    }) => {
      biLogger.log(E.audioPluginDetails, {
        plugin_id: pluginId,
        creator,
        title,
        track_duration: track_duration?.toString(),
        url,
        type,
        version,
        content_id,
        pluginUniqueId: void 0,
        container: void 0,
        container_id: void 0,
        container_platform: void 0,
        params: void 0
      });
    }
  };
};
function modalAction(params) {
  return { evid: 59, src: 116, endpoint: "", params };
}
const analyticsAnyButtonClickAction = (params) => {
  return { evid: 1113, src: 76, endpoint: "", params };
};
const buildAnyButtonClickActionParams = (contentId, partialNode) => {
  if (partialNode) {
    const commonParams = {
      element_id: contentId || "",
      url: typeof window !== "undefined" ? window.location.href : "",
      elementGroup: "Ricos",
      actionName: ""
    };
    switch (partialNode.type) {
      case Node_Type.BUTTON: {
        return {
          ...commonParams,
          elementTitle: partialNode.buttonData?.text || "",
          details: partialNode.buttonData?.link?.rel ? JSON.stringify(partialNode.buttonData.link.rel) : "",
          elementType: Node_Type.BUTTON,
          value: partialNode.buttonData?.link?.url || ""
        };
      }
      case Node_Type.LINK_PREVIEW: {
        return {
          ...commonParams,
          elementTitle: partialNode.linkPreviewData?.title || "",
          details: partialNode.linkPreviewData?.link?.rel ? JSON.stringify(partialNode.linkPreviewData.link.rel) : "",
          elementType: Node_Type.LINK_PREVIEW,
          value: partialNode.linkPreviewData?.link?.url || ""
        };
      }
      case Node_Type.APP_EMBED: {
        return {
          ...commonParams,
          elementTitle: partialNode.appEmbedData?.name || "",
          details: partialNode.appEmbedData?.type || "",
          elementType: Node_Type.APP_EMBED,
          value: partialNode.appEmbedData?.url || ""
        };
      }
      case Node_Type.TEXT: {
        const linkDecoration = partialNode.textData?.decorations?.find(
          ({ type }) => type === Decoration_Type.LINK
        );
        if (linkDecoration) {
          return {
            ...commonParams,
            elementTitle: partialNode.textData?.text || "",
            details: linkDecoration?.linkData?.link?.rel ? JSON.stringify(linkDecoration.linkData.link.rel) : "",
            elementType: Decoration_Type.LINK,
            value: linkDecoration?.linkData?.link?.url || ""
          };
        }
        break;
      }
      default: {
        return;
      }
    }
  }
  return;
};
export {
  ricosBICallbacks
};
//# sourceMappingURL=ricosBICallbacks.js.map
